<template>
    <div class="police">
        <span class="all-police">全部警种：</span>
        <ul class="police-ul">
            <li :class="item.active" v-for="(item,index) in policeList" :key="index">{{item.name}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            policeList:[
                {name:'全部',active:'active'},
                {name:'情报'},
                {name:'指挥'},
                {name:'纪检'},
                {name:'督察'},
                {name:'审计'},
                {name:'国保'},
                {name:'治安'},
                {name:'经侦'},
                {name:'刑侦'},
                {name:'禁毒'},
                {name:'警卫'},
                {name:'警务飞行'}
            ]
        }
    },
    methods:{

    },

}
</script>

<style lang="scss" scoped>
.police{
    width: 1200px;
    height: 72px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    .all-police{
        height: 19px;
        font-size: 19px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        opacity: 1;
        line-height: 18px;
        margin-left: 35px;
    }
    .police-ul{
        width: 1018px;
        display: flex;
        justify-content: space-between;
        padding-left: 18px;
        padding-right: 32px;
        &>li{
            width: 58px;
            height: 28px;
            background: #ECECEC;
            opacity: 1;
            border-radius: 6px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 27px;
            color: #333333;
            text-align: center;
        }
        &>li:last-child{
             width: 90px;
        }
        &>.active{
            background: rgba(72, 118, 196, 0.95);
        }
    }
}
</style>